import DefaultLoader from '@sportnet/ui/lib/Loader';
import React from 'react';
import styled from '../../theme/styled-components';

const Wrapper = styled('div')`
  width: 100%;
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class Loader extends React.PureComponent<{}> {
  render() {
    return (
      <Wrapper>
        <DefaultLoader size="xl" />
      </Wrapper>
    );
  }
}

export default Loader;
